import React, { useMemo, useState } from 'react';

export default function TestApiPage() {
  const [csrfToken, setCsrfToken] = useState('');
  const [email, setEmail] = useState(() => `test+${Date.now()}@example.com`);
  const [password, setPassword] = useState('Password123!');
  const [name, setName] = useState('Test');
  const [phone, setPhone] = useState('771234567');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const base = useMemo(() => '/api/index.php?__path__=', []);

  const parseResponse = async (res) => {
    const contentType = res.headers.get('content-type') || '';
    const text = await res.text();

    let json = null;
    if (contentType.includes('application/json')) {
      try {
        json = text ? JSON.parse(text) : null;
      } catch {
        json = null;
      }
    }

    return {
      status: res.status,
      ok: res.ok,
      contentType,
      json,
      text: json ? null : text,
    };
  };

  const show = async (label, fn) => {
    setLoading(true);
    try {
      const out = await fn();
      setResult({ label, out });
    } catch (e) {
      setResult({ label, error: String(e?.message || e) });
    } finally {
      setLoading(false);
    }
  };

  const doCsrf = () =>
    show('csrf', async () => {
      const res = await fetch(base + 'csrf', {
        method: 'GET',
        credentials: 'include',
      });
      const out = await parseResponse(res);
      if (out?.json?.csrfToken) setCsrfToken(out.json.csrfToken);
      return out;
    });

  const doRegister = () =>
    show('register', async () => {
      const res = await fetch(base + 'register', {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': csrfToken,
        },
        body: JSON.stringify({ name, email, password, phone }),
      });
      return parseResponse(res);
    });

  const doLogin = () =>
    show('login', async () => {
      const res = await fetch(base + 'login', {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': csrfToken,
        },
        body: JSON.stringify({ email, password }),
      });
      return parseResponse(res);
    });

  const doMe = () =>
    show('me', async () => {
      const res = await fetch(base + 'me', {
        method: 'GET',
        credentials: 'include',
      });
      return parseResponse(res);
    });

  const doLogout = () =>
    show('logout', async () => {
      const res = await fetch(base + 'logout', {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': csrfToken,
        },
      });
      return parseResponse(res);
    });

  return (
    <div style={{ maxWidth: 720, margin: '0 auto', padding: 16 }}>
      <h2>Test API</h2>

      <div style={{ display: 'grid', gap: 10 }}>
        <label>
          Email
          <input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ width: '100%', padding: 8 }}
          />
        </label>

        <label>
          Password
          <input
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ width: '100%', padding: 8 }}
          />
        </label>

        <label>
          Name
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            style={{ width: '100%', padding: 8 }}
          />
        </label>

        <label>
          Phone
          <input
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            style={{ width: '100%', padding: 8 }}
          />
        </label>

        <label>
          CSRF Token
          <input value={csrfToken} readOnly style={{ width: '100%', padding: 8 }} />
        </label>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
          <button onClick={doCsrf} disabled={loading}>CSRF</button>
          <button onClick={doRegister} disabled={loading || !csrfToken}>Register</button>
          <button onClick={doLogin} disabled={loading || !csrfToken}>Login</button>
          <button onClick={doMe} disabled={loading}>Me</button>
          <button onClick={doLogout} disabled={loading || !csrfToken}>Logout</button>
        </div>

        <div>
          <pre style={{ whiteSpace: 'pre-wrap', background: '#111', color: '#eee', padding: 12, borderRadius: 8 }}>
            {result ? JSON.stringify(result, null, 2) : 'No result yet'}
          </pre>
        </div>

        <div style={{ opacity: 0.8 }}>
          Path: <code>/test-api</code>
        </div>
      </div>
    </div>
  );
}
